export const foodDirectorsStatic = {
  crumbsNav: [
    { id: 1, title: 'Home', link: '/' },
    { id: 2, title: 'Directors', link: '/directors/' },
  ],
  tickers: ['Reel', 'Directors', 'Reel', 'Directors'],
};
